module.exports = __webpack_public_path__ + "static/media/partner-ubs.f29d9728.png";